var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g-layout-footer"}},[_c('div',{staticClass:"v-footer"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"mailto:vandkortet@niras.dk"}},[_vm._v(_vm._s(_vm.$t('footer.contact')))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }